/**
 * Registry rule id -> the card a "Why?" link opens (aligned 13 Oct 2026 with
 * backend/src/rfq_foundry/rules, release 2026.10.3).
 *
 * The eight `preflight.*` rules (the master data checks of a finished draft, switch
 * `RFQ_PREFLIGHT`, default off) share one card: sales read them as one kind of check.
 *
 * A string is the card for every company. A map is per entity, for a rule that runs in a
 * few companies only and is explained on their country cards. `tests/rules-explainer.test.mjs`
 * reads the registry ids from the backend and fails when one has no target here.
 */
export const WHY_TARGETS: Readonly<Record<string, string | Readonly<Record<string, string>>>> = {
  "gate.competitor": "competitor-domains",
  "gate.sanctioned": "sanctioned-countries",
  "gate.portal": "portal-customers",
  "gate.uk_wgg": "uk-quote-from-germany",
  "gate.uk_export": "uk-export-customers",
  "gate.media": "media-items",
  "gate.service_visit": "service-visit-parts",
  "gate.out_of_scope_group": "out-of-scope-item-groups",
  "gate.doa_limit": "large-quotation",
  "gate.hsn": "in-hsn",
  "gate.signal_review": "signal-codes",
  "gate.signal_generic": { dk: "dk-generic-items", usl: "na-generic-items" },
  "gate.successor": "successor-items",
  "gate.evaluation_failed": "rule-check-failed",
  "header.pool": "quotation-header",
  "header.not_available": "quotation-header",
  "header.from_last_quotation": "quotation-header",
  "pricing.freight": "freight",
  "pricing.margin": "contribution-ratio",
  "pricing.no_price": "never-zero-price",
  "pricing.lead_time": "lead-time-warnings",
  "pricing.after_requested": "lead-time-warnings",
  "pricing.ship_today": "lead-time-warnings",
  "pricing.price_age": "price-age",
  "pricing.vs_last_quote": "last-quotation-history",
  "preflight.item_exists": "master-data-checks",
  "preflight.item_released": "master-data-checks",
  "preflight.item_blocked": "master-data-checks",
  "preflight.price_available": "master-data-checks",
  "preflight.quantity": "master-data-checks",
  "preflight.customer_valid": "master-data-checks",
  "preflight.currency": "master-data-checks",
  "preflight.duplicate_reference": "master-data-checks",
};
